/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useRef } from "react";
import {
  useOrders,
  loadOrder,
  getDepartments,
  getOrderNotes,
  getOrderCredit,
  addError,
  sendMessage,
  createNote,
  getPriceListProducts,
  submitOrder,
  checkDeliveryDate,
  updateOrder,
  clearSuccess,
  clearErrors,
  emptyOrders,
  clearUploadMessages,
  setEnlarged,
  hideForbiddenNotice,
  toggleDepartment,
  searchByFamily, 
  setOrderSearchFamily,
  setDirty,
  setCreditProcess,
  getPaymentUrl,
  setBadProduct,
  cancelTextSearch
} from "../../context/orders/OrdersState";

import { useAuth } from "../../context/auth/AuthState";
import AlertContext from "../../context/alert/alertContext";
import { Loader } from "@progress/kendo-react-indicators";
import { useParams, useNavigate } from "react-router-dom";
import Product from "./Product";
import CartItem from "./CartItem";
import Payment from "./Payment";
import ProductsFilter from "./ProductsFilter";
import Title from "./Title";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import UploadFile from "./UploadFile";
import Departments from "./Departments";
import ProductImage from "./ProductImage";
import { Scrollbars} from "react-custom-scrollbars-2";
import BeforeUnloadComponent  from 'react-beforeunload-component';
import popupStyles from "../../css/custom-popup.module.css"

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import OrderMobile from "./OrderMobile";
import { button, div } from "react-dom-factories";
const Order = () => {
  const [ordersState, ordersDispatch] = useOrders();
  const {
    currentOrder,
    departments,
    families,
    products,
    relevantFamilies,
    relevantDeps,
    sendMessages,
    notes,
    credit,
    total,
    plProducts,
    error,
    success,
    uploadMessages,
    loading,
    successPopUp,
    missingNoteType,
    enlarged,
    draftStatus,
    actions,
    forbiddenNotice,
    showPrices,
    useCredit,
    credit_process,
    url,
    bad_product,
    updateSuccess
  } = ordersState;
  const [authState] = useAuth();
  const { user } = authState;

  const navigate = useNavigate();
  
  // for alerts
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;

  const [submitLoad, setSubmitLoad] = useState(false);

  const { id } = useParams();
  const [tab, setTab] = useState("products");
  const [weekOver, setWeekOver] = useState(0);
  const [showWeekOver, setShowWeekOver] = useState(false);
  const [showWeekMin, setShowWeekMin] = useState(false);
  const [monthOver, setMonthOver] = useState(0);
  const [showMonthOver, setShowMonthOver] = useState(false);
  
  const [ignoreBudget,setIgnoreBudget]=useState(false)
  const [ignoreForbidden,setIgnoreForbidden]=useState(false)
  const [saving,setSaveing]=useState(false)
  const [sendWithNoBudget, setSendWithNoBudget]=useState(actions?.includes('sendWithNoBudget'))
  const [updateForbidden, setUpdateForbidden]=useState(actions?.includes('updateForbidden'))

  const [isDirty, setIsDirty] = useState(false);
  const [initialTotal, setInitialTotal] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [totalWithFee, setTotalWithFee] = useState(0);
  const [paymentFinished, setPaymentFinished] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [showCreditPopup, setShowCreditPopup] = useState(false);

  const [IsInitialLoad, setIsInitialLoad] = useState(true);
  const [showSavedMessage, setShowSavedMessage] = useState(false);

 
  useEffect(() => {
    // if UnAuthorized - refresh page
    if (
      typeof error !== "undefined" &&
      error !== null &&
      typeof error.data !== "undefined" &&
      error.data.status === 401
    ) {
      window.location.reload();
    }
    if (error !== "") {
      setAlert(error, "danger");
      clearErrors(ordersDispatch);
    }
  }, [error]);

  useEffect(()=>{
    
    if (ignoreBudget) {
      showSendPopUp();
    }
  },[ignoreBudget])

  console.log("currentOrder " + currentOrder);
  useEffect(() => {
      console.log('updateSuccess', updateSuccess)
      console.log(loading)
      if(updateSuccess !== "" && updateSuccess !== null && loading == false)
        setShowSavedMessage(true);
      
      // אחרי 3 שניות נעלים את ההודעה גם מקומית וגם מה-State הגלובלי
      const timer = setTimeout(() => {
        setShowSavedMessage(false);
        clearSuccess(ordersDispatch);
      }, 3000);
      
      return () => clearTimeout(timer);
    
  }, [updateSuccess, loading]);
  
  useEffect(()=>{
    
    if (ignoreForbidden) {
      showSendPopUp();
    }
  },[ignoreForbidden])

  useEffect(() => {
    if (currentOrder && currentOrder.delivery_fee && total && total < currentOrder.max_for_fee) {
      setDeliveryFee(currentOrder.delivery_fee);
      setTotalWithFee(total + currentOrder.delivery_fee);
    } else {
      setDeliveryFee(0);
      setTotalWithFee(total);
    }


  }, [total, currentOrder?.delivery_fee]);

  useEffect(() => {
    // a product search still pending for the previous order must not land on this one
    cancelTextSearch();
    if (id) {
        const fetchData = async () => {
          clearSuccess(ordersDispatch);
          await loadOrder(ordersDispatch, id);
          await getDepartments(ordersDispatch);
          await getPriceListProducts(ordersDispatch, id);
          setIsInitialLoad(false);
        };
      
        fetchData();
        setTimeout(showHideMissing, 1500);
      }
  }, [ordersDispatch, id]);

  useEffect(() => {
    setShowPopUp(!showPopUp && (ignoreForbidden || forbiddenNotice === 2));
  }, [forbiddenNotice]);


  const savedMessageTimerRef = useRef(null); 

 /*  const handleSuccess = () => {
    console.log("1. השרשרת התחילה - handleSuccess נקרא!");    
    // ניקוי טיימר קודם אם קיים (כדי למנוע באגים בלחיצות מהירות)
    if (savedMessageTimerRef.current) {
      clearTimeout(savedMessageTimerRef.current);
    }

    setShowSavedMessage(true);

    savedMessageTimerRef.current = setTimeout(() => {
      setShowSavedMessage(false);
      savedMessageTimerRef.current = null;
    }, 3000);
  };   */
  console.log('showSavedMessage', showSavedMessage)
  const showSendPopUp = async() => {

    setSaveing(true) 
   
    if (weekOver > 0 && !ignoreBudget) {
      console.log('1');
      setShowWeekOver(true);

      // check also monthly
      if (monthOver > 0) {
        console.log('2');
        setShowMonthOver(true);
      }

      // chek also min weekly
      if (totalWithFee < currentOrder.min_order_weekly) {
        console.log('3');
        setShowWeekMin(true);
      }

    } else if (monthOver > 0 && !ignoreBudget) {
      console.log('4');
      setShowMonthOver(true);

      // chek also min weekly
      if (totalWithFee < currentOrder.min_order_weekly) {
        console.log('5');
        setShowWeekMin(true);
      }

    } else if (totalWithFee < currentOrder.min_order_weekly && !ignoreBudget) {
      console.log('6');
      setShowWeekMin(true);
    } else { 
      if (currentOrder?.actions?.indexOf("send-update") > -1 && !showPopUp && !ignoreForbidden) {
        console.log('7');
        checkDeliveryDate(ordersDispatch, id);
      } else {
        console.log('8');
        setShowPopUp(!showPopUp);
        
        if (!ignoreForbidden) {
          console.log('9');
          hideForbiddenNotice(ordersDispatch);  // to set forbiddenNotice to 0 again
        }
      }
    }

  };

  const [showMissing, setShowMissing] = useState(false);
  const showHideMissing = () => {
    setShowMissing(!showMissing);
  };
  
  useEffect(() => {
    if (currentOrder) {
      if (currentOrder.max_order_weekly > 0 && currentOrder?.fields?.type == 'regular') {
        let over = totalWithFee - currentOrder.max_order_weekly;

        setWeekOver(over);
        setShowWeekOver(over > 0);
        
      }
      if (currentOrder.max_orders_monthly > 0 && currentOrder?.fields?.type == 'regular') {
        let over = totalWithFee - currentOrder.priorityTotal -
        parseInt(currentOrder.budget_left);
        setMonthOver(over);
        setShowMonthOver(over > 0);
        
      }
    }

    // eslint-disable-next-line
  }, [totalWithFee, currentOrder?.fields?.delivery_date]);

  useEffect(()=>{
   setSendWithNoBudget(actions?.includes('sendWithNoBudget'))
   setUpdateForbidden(actions?.includes('updateForbidden'))
  },[actions]) 

  useEffect(() => {
    if (successPopUp && currentOrder === null) {
      emptyOrders(ordersDispatch);
      navigate("/orders/");
    }
    if (currentOrder) {
      if (Object.keys(currentOrder).length !== 0) {
        getOrderNotes(ordersDispatch, currentOrder);
        if (useCredit && actions?.includes('watchCredit')) {
          getOrderCredit(ordersDispatch, currentOrder);
        }
      }
    }
    
  }, [currentOrder]);

  useEffect(() => {
    if (initialTotal === 0 && total > 0) {
      setInitialTotal(total);
    } else {
      if (total !== initialTotal) {
        setIsDirty(true);
      }
    }
  }, [total]);
  

  const sendClick = (e) => {
    sendMessage(ordersDispatch, id, document.getElementById("inputText").value);
    document.getElementById("inputText").value = "";
  };

  const noteClick = (e) => {
    createNote(ordersDispatch, id, {
      text: document.getElementById("inputText").value,
    });
    document.getElementById("inputText").value = "";
  };

  useEffect(() => {
    if (success !== "" && success !== null) {
      setAlert(success, "success");
      clearSuccess(ordersDispatch);
    }
  }, [success]);
 
  useEffect(() => {
    
    if (credit_process) {
      const fetchPaymentForm = async () => {
        try {
          setPaymentFinished(false);
          getPaymentUrl(ordersDispatch, totalWithFee, currentOrder?.fields?.id);
        } catch (error) {
          console.error('Error fetching payment form:', error);
        }
      };
      
      fetchPaymentForm();
    } 
  }, [credit_process]);
  
  // listen to the payment iframe
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.paymentStatus === 'finished') {
        setPaymentFinished(true);
      } else if (event.data.paymentStatus === 'fail') {
        setCreditProcess(ordersDispatch, false);
        // Cleanup the event listener on component unmount
        return () => {
          window.removeEventListener('message', handleMessage);
        };
      } else if (event.data.paymentStatus === 'success') {
        setPaymentSuccess(true);
        // Cleanup the event listener on component unmount
        return () => {
          window.removeEventListener('message', handleMessage);
        };
      } 
    };

    window.addEventListener('message', handleMessage);

    
  }, []);



  useEffect(() => {
    if (paymentSuccess) {
      setSubmitLoad(true);
      submitOrder(
        ordersDispatch,
        currentOrder.fields.id,
        currentOrder.fields.delivery_date,
        currentOrder.fields.customer_id,
        products
      );
      setIgnoreBudget(false);
      setCreditProcess(ordersDispatch, false);
    }
  }, [paymentSuccess]);


  if (departments === null || departments.length === 0) {
    return "";
  }

  const onSubmitUpdate = () => {
    showSendPopUp();
    setSubmitLoad(true);
    updateOrder(ordersDispatch, currentOrder.fields.id);
    setIgnoreBudget(false)

  };

  const onSubmit = () => {
    
    if (useCredit) {
      showSendPopUp();
     setCreditProcess(ordersDispatch, true);
    } else {
    
      showSendPopUp();
      setSubmitLoad(true);
      
      submitOrder(
        ordersDispatch,
        currentOrder.fields.id,
        currentOrder.fields.delivery_date,
        currentOrder.fields.customer_id,
        products,
        currentOrder.fields.type,
      );
      setIgnoreBudget(false)
    }
  };

  const clearUpload = (e) => {
    clearUploadMessages(ordersDispatch);
  };

  const clearBadProduct = (e) => {
    setBadProduct(ordersDispatch, false);
  }

  

  const myHandleLeave = ({ onLeave, onStay }) => {
    
    return <Dialog
    title='שימ/י לב:'
    onClose={onStay}
    open={isDirty}
    className="pop-up pop-up-orange"
  >
    <p>
      על מנת שהעדכון יתבצע יש ללחוץ על כפתור שליחת עדכון. <br></br>האם אתה בטוח שברצונך לצאת?
    </p>
    <DialogActionsBar>
      <button
        className="cancel btn"
        onClick={onLeave}
      >
        אני רוצה לצאת
      </button>
      <button
        className="submit btn"
        onClick={onStay}
      >
        אני רוצה להשאר
      </button>
    </DialogActionsBar>
  </Dialog> ;
  }
  console.log("currentOrder " + currentOrder?.fields?.type);
  return (
    <BeforeUnloadComponent
    blockRoute={currentOrder?.fields?.status > draftStatus && isDirty}
    modalComponentHandler={({handleModalLeave, handleModalCancel})=>{
      return myHandleLeave({onLeave: handleModalLeave, onStay: handleModalCancel});
  }}
    
    >
    <div className="divAllPage ordersPage d-flex">
       <Title navigate={navigate} orderType={currentOrder?.fields?.type} />
      {isBrowser && (
        <div className="d-flex all_content">
          <Departments />
          <div className="products">
            <div className="productsHeader d-flex">
              <ProductsFilter />
              {user?.can_upload_file !== 0 && <UploadFile />}
            </div>
            <div className="products_disc">
                הנתונים המדויקים מופיעים על גבי המוצר, אין להסתמך על הפירוט המופיע באתר, יתכנו טעויות או אי התאמות, יש לקרוא את המופיע על גבי אריזת המוצר לפני השימוש.
                <br/>
התמונות והתאריכים המופיעים הינם להמחשה בלבד ואין להסתמך עליהם.
</div>
            <div className={"divWarpGrid" + (!showPrices ? " no_price" : "")}>
              <div className="products-title">
                <div className='table_pic'>תמונה</div>
                <div className="table_desc">מוצר</div>
                <div className="table_qty">כמות</div>
                <div className="table_unit">יחידה</div>
                {showPrices && <div className="table_price">מחיר</div>}
              </div>
              <Scrollbars style={{ direction: "rtl", height: 500 }}>
                {plProducts.map((product) => (
                  <Product key={product.id} product={product} showPrices={showPrices}/>
                ))}
              </Scrollbars>
            </div>
          </div>

          <div className="card cart">
            <div className="card_wrapper">
              <div className="card_tabs">
                <button
                  className={
                    tab === "products"
                      ? "card_tabsBtn cart active"
                      : "card_tabsBtn cart inactive"
                  }
                  onClick={() => {
                    setTab("products");
                  }}
                  style={{
                    width: sendMessages || notes.length > 0 ? "50%" : "100%",
                    justifyContent:
                      sendMessages || notes.length > 0 ? "center" : "start",
                    padding:
                      sendMessages || notes.length > 0 ? "0 5px" : "0 25px",
                  }}
                >
                  <svg
                    width="21.525"
                    height="23.709"
                    viewBox="0 0 21.525 23.709"
                  >
                    <g id="add-to-cart" transform="translate(0.251 0.25)">
                      <path
                        id="Path_34"
                        data-name="Path 34"
                        d="M218.432,132.006l-2.06,2.06a.68.68,0,0,1-.962,0l-2.06-2.06a.68.68,0,1,1,.962-.962l.9.9v-2.728a.68.68,0,0,1,1.36,0v2.728l.9-.9a.68.68,0,0,1,.962.962Zm0,0"
                        transform="translate(-207.269 -122.709)"
                        fill="#bad564"
                        stroke="#bad564"
                        strokeWidth="0.5"
                      />
                      <path
                        id="Path_35"
                        data-name="Path 35"
                        d="M.68,16.023H13.552a1.358,1.358,0,0,0,1.308-1.2l.033-.358H3.271A2.728,2.728,0,0,1,.608,12.038l-.6-6.57A2.316,2.316,0,0,1,2.344,2.913h13.6l.044-.481A2.693,2.693,0,0,1,18.587,0h1.758a.68.68,0,0,1,0,1.36H18.587a1.323,1.323,0,0,0-1.245,1.195l-.1,1.107h0L16.215,14.951a2.728,2.728,0,0,1-2.663,2.432H.68a.68.68,0,0,1,0-1.36ZM2.344,4.273a.957.957,0,0,0-.979,1.072l.6,6.57a1.358,1.358,0,0,0,1.309,1.2H15.017l.8-8.837Zm0,0"
                        transform="translate(0)"
                        fill="#bad564"
                        stroke="#bad564"
                        strokeWidth="0.5"
                      />
                      <path
                        id="Path_36"
                        data-name="Path 36"
                        d="M338.14,417.73A2.137,2.137,0,1,1,336,419.867,2.139,2.139,0,0,1,338.14,417.73Zm0,2.913a.777.777,0,1,0-.777-.777A.778.778,0,0,0,338.14,420.644Zm0,0"
                        transform="translate(-334.484 -398.795)"
                        fill="#bad564"
                        stroke="#bad564"
                        strokeWidth="0.5"
                      />
                      <path
                        id="Path_37"
                        data-name="Path 37"
                        d="M145.344,417.73a2.137,2.137,0,1,1-2.137,2.137A2.139,2.139,0,0,1,145.344,417.73Zm0,2.913a.777.777,0,1,0-.777-.777A.777.777,0,0,0,145.344,420.644Zm0,0"
                        transform="translate(-132.947 -398.795)"
                        fill="#bad564"
                        stroke="#bad564"
                        strokeWidth="0.5"
                      />
                    </g>
                  </svg>
                  <p
                    className={
                      sendMessages || notes.length > 0 ? "twoTabs" : "oneTab"
                    }
                  >
                    עגלת קניות <span>({products.length} מוצרים)</span>
                  </p>
                </button>
                {(sendMessages || notes.length > 0) && (
                  <button
                    className={
                      tab === "notes"
                        ? "card_tabsBtn active notes"
                        : "card_tabsBtn inactive notes"
                    }
                    onClick={() => {
                      setTab("notes");
                    }}
                  >
                    <svg
                      id="Group_192"
                      data-name="Group 192"
                      width="22.864"
                      height="20.398"
                      viewBox="0 0 22.864 20.398"
                    >
                      <path
                        id="Path_72"
                        data-name="Path 72"
                        d="M2.974,12.444H1V1H16.8V3.081"
                        transform="translate(1.215 1.158)"
                        fill="none"
                        stroke="#bad564"
                        strokeWidth="2"
                      />
                      <path
                        id="Path_73"
                        data-name="Path 73"
                        d="M7,7v9.7h7.5v3.086L17.581,16.7h3.527V7Z"
                        transform="translate(-0.452 -0.452)"
                        fill="none"
                        stroke="#bad564"
                        strokeWidth="2"
                      />
                    </svg>
                    עדכונים
                  </button>
                )}
                {(actions?.includes('watchCredit') && useCredit) ?
                  (<button
                  className={
                    tab === "credit"
                      ? "card_tabsBtn active notes"
                      : "card_tabsBtn inactive notes"
                  }
                  onClick={() => {
                    setTab("credit");
                  }}
                >
                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M22 3c.53 0 1.039.211 1.414.586s.586.884.586 1.414v14c0 .53-.211 1.039-.586 1.414s-.884.586-1.414.586h-20c-.53 0-1.039-.211-1.414-.586s-.586-.884-.586-1.414v-14c0-.53.211-1.039.586-1.414s.884-.586 1.414-.586h20zm1 8h-22v8c0 .552.448 1 1 1h20c.552 0 1-.448 1-1v-8zm-15 5v1h-5v-1h5zm13-2v1h-3v-1h3zm-10 0v1h-8v-1h8zm-10-6v2h22v-2h-22zm22-1v-2c0-.552-.448-1-1-1h-20c-.552 0-1 .448-1 1v2h22z"/></svg>
                  אשראי
                </button>)
                : null
                }
              </div>
              {tab === "products" && (
                
                <Scrollbars style={{ height: showPrices ? currentOrder?.fields?.type == 'base' ? "calc(100% - 225px)" : "calc(100% - 258px)" : "calc(100% - 138px)" }}>
                  {products.map((product) => (
                    <CartItem key={product.id} item={product} showPrices={showPrices} />
                  ))}
                </Scrollbars>
                
              )}

              {(tab === "products" && currentOrder) && (
                <div>
                  <div className={currentOrder.fields?.type == 'base' ? 'baseOrder orderSum':'orderSum'}>
                    
                    {showPrices &&
                      <>
                        
                          <div className="orderSum_desc">
                            <div className="sum-text">
                              <span className="sum-text_subtitle">סה"כ
                              <span className="sum-text_subtitle">  (כולל מע"מ)</span>
                              </span>
                            </div>
                            
                            <div className="sum-number-small">
                              {Math.round(total * 100) / 100}{" "}
                              <i className="fas fa-shekel-sign"></i>
                            </div>
                          </div>
                          <div className="orderSum_desc">
                            <div className="sum-text">
                              <span className="sum-text_subtitle">דמי משלוח
                              </span>
                            </div>
                            <div className="sum-number-small">
                              {Math.round(deliveryFee * 100) / 100}{" "}
                              <i className="fas fa-shekel-sign"></i>
                            </div>
                          </div>
                        
                        <div className="orderSum_desc">
                          <div className="sum-text">
                            <span className="sum-text_title">{currentOrder?.fields?.type == 'regular' ? 'לתשלום' : 'סה"כ הזמנת בסיס' }
                            </span>
                          </div>
                          <div className="sum-number">
                          {Math.round(totalWithFee * 100) / 100}{" "}
                            <i className="fas fa-shekel-sign"></i>
                          </div>
                        </div>
                      </>
                    }
                    {currentOrder.actions?.length > 0 && currentOrder?.fields?.type == 'regular' ? (
                      <button
                        disabled={loading || !total}
                        onClick={showSendPopUp}
                        className={"send-order-btn" + ((loading || !total) ? " disabled-btn" : "")}
                      >
                    {loading ?
                      <Loader type="pulsing" />
                      : currentOrder.actions?.indexOf("send-update") > -1
                          ? "שליחת עדכון"
                          : "שליחת הזמנה"
                        }
                      </button>
                    ):<button
                    disabled={true}
                    className={"send-order-btn disabled-btn savedMessageBtn"}>
                    {loading ? (
                      <Loader type="pulsing"/>)
                      : showSavedMessage ?
                      updateSuccess
                      :''
                    }
                   
                  </button>}
                  </div>
                </div>
              )}
              {tab === "notes" && sendMessages && (
                <div className="card_top">
                  <div className="card_text">
                    <textarea
                      id="inputText"
                      type="text"
                      name="name"
                      placeholder="כתוב כאן..."
                    ></textarea>
                  </div>
                  <div className="card_btns" id="divBtnPopup">
                    <button
                      className="btnPopup btnSendSMS"
                      id="btnSendSMS"
                      onClick={sendClick}
                    >
                      <i className="fas fa-sms"></i>שליחת SMS
                    </button>
                    <button
                      className="btnPopup btnAddMessage"
                      id="btnAddMessage"
                      onClick={noteClick}
                    >
                      <i className="fas fa-comment-dots"></i>הוספת הודעה
                    </button>
                  </div>
                </div>
              )}
              {(actions?.includes('watchCredit') && tab === "credit") && 
                <div className="card_comments">
                  {credit.length > 0 ? 
                      (<>
                        <div className="credit_line title">
                            <div Style="width:15%" className="credit_data">פעולה</div>
                            <div Style="width:20%" className="credit_data">סכום (ש"ח)</div>
                            <div Style="width:35%" className="credit_data">תאריך</div>
                            <div Style="width:15%" className="credit_data">כרטיס</div>
                            <div Style="width:15%" className="credit_data">סטטוס</div>
                          </div>
                        {credit?.map((c) => {
                            return (
                            <div key={c.id} className="credit_line">
                                <div Style="width:15%" className="credit_data">{c.type}</div>
                                <div Style="width:20%" className="credit_data">{c.amount}</div>
                                <div Style="width:35%" className="credit_data">{c.credit_date}</div>
                                <div Style="width:15%" className="credit_data">{c.four_digits}</div>
                                <div Style="width:15%" className="credit_data">{c.status ? 'הצליח' : 'נכשל'}</div>
                            </div>
                            );
                        })}
                      </>)
                      : (<div className='no_credit'>אין פעולות אשראי</div>)
                  }
                </div>
              }
              <div
                className={
                  sendMessages ? "master card_content" : "card_content"
                }
              >
                {tab === "notes" && (
                  <div className="card_comments">
                    {notes.map((note) => {
                      return (
                        <div key={note.id} className="mess_line">
                          <div className="note">
                            <div
                              className="avatar"
                              style={{
                                backgroundColor: note.color,
                                color: note.textColor,
                              }}
                            >
                              {note.name}
                            </div>
                            <div
                              className="mess_text"
                              dangerouslySetInnerHTML={{ __html: note.text }}
                            ></div>
                          </div>
                          <div className="mess_date">{note.date}</div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isMobile && <div><OrderMobile showSendPopUp={showSendPopUp} cartProducts={products} products={plProducts} deliveryFee={deliveryFee} totalWithFee={totalWithFee} showSavedMessage={showSavedMessage} ></OrderMobile> </div>}
      {submitLoad && loading && (
        <div className="overley_page">
          <Loader type="converging-spinner" />
        </div>
      )}
      {(showPopUp) &&(
        <Dialog
          title={
            currentOrder?.actions?.indexOf("send-update") > -1
              ? "האם לעדכן את ההזמנה?"
              : "האם לשלוח את ההזמנה?"
          }
          onClose={(e) => {showSendPopUp();setSaveing(false);}}
          className="pop-up"
        >
          <p>
            {currentOrder?.actions?.indexOf("send-update") > -1
              ? "לאחר שליחת עדכון, תוכל לשוב ולעדכן את ההזמנה לזמן מוגבל."
              : "לאחר שליחת הזמנה, תוכל לשוב ולעדכן את ההזמנה לזמן מוגבל."}
          </p>
          <DialogActionsBar>
          <button
              className="submit btn"
              onClick={(e)=>{ (useCredit && currentOrder?.actions?.indexOf("send-update") === -1) ? 
                (() => { setShowCreditPopup(true); })() : 
                (  
                currentOrder?.actions?.indexOf("send-update") > -1
                  ? onSubmitUpdate()
                  : onSubmit()
                )
                }
              }
            >
              אישור
            </button>
            <button className="cancel btn" onClick={(e)=>{showSendPopUp(); setIgnoreBudget(false); setIgnoreForbidden(false);setSaveing(false);} }>
              ביטול
            </button>
          </DialogActionsBar>
        </Dialog>
      )}
      { showCreditPopup &&
        <Dialog
        title={
          'שימ/י לב:'
        }
        onClose={(e) => {showSendPopUp();setSaveing(false);}}
        className="pop-up pop-up-orange"
      >
        <p>
          {"סכום הסל המוצג לתשלום הינו סכום מוערך, ועשוי להשתנות בשל מוצרים שקילים"}
        </p>
        <DialogActionsBar>
        <button
            className="submit btn"
            onClick={() => {  setShowCreditPopup(false);
              currentOrder?.actions?.indexOf("send-update") > -1
                ? onSubmitUpdate()
                : onSubmit()
            }}
          >
            אישור
          </button>
          <button className="cancel btn" onClick={(e)=>{showSendPopUp();setIgnoreBudget(false); setIgnoreForbidden(false);setSaveing(false);setShowCreditPopup(false)} }>
            ביטול
          </button>
        </DialogActionsBar>
      </Dialog>
      }

      {showMissing && notes.filter((note) => note.type === missingNoteType).length > 0 &&
      <Dialog
          title='שימ/י לב:'
          onClose={showHideMissing}
          className="pop-up"
        >
           {notes.filter((note) => note.type === missingNoteType).map((note) => {
              return (
                <div><b>{note.text}</b></div>
              );
            })}
          <DialogActionsBar>
            <button
              className="submit btn"
              onClick={showHideMissing}
            >
              אישור
            </button>
          </DialogActionsBar>
        </Dialog>
        }

      {uploadMessages && uploadMessages.length > 0 && (
        <Dialog
        title='שימ/י לב:'
        onClose={clearUpload}
        className="pop-up"
        height="250px"
      >
         {uploadMessages.map((msg) => {
            return (
              <div><b>{msg}</b></div>
            );
          })}
        <DialogActionsBar>
          <button
            className="submit btn"
            onClick={clearUpload}
          >
            אישור
          </button>
        </DialogActionsBar>
      </Dialog>
      )}
        
      {(forbiddenNotice === 1 && (!updateForbidden || !saving)) &&
        <Dialog
        title={"מצטערים..."}
        onClose={() => hideForbiddenNotice(ordersDispatch)}
        className="pop-up successPopUp pop-up-orange"
        >
        <p>כבר לא ניתן לשלוח את ההזמנה לעדכון. אנא פנה למשרד</p>
        <DialogActionsBar>
          
          <button
            className="submit btn"
            onClick={() => hideForbiddenNotice(ordersDispatch)}
          >
            אישור
          </button>
        </DialogActionsBar>
        </Dialog>
      }
      {(forbiddenNotice === 1 && updateForbidden && saving) &&
        <Dialog
        title={"שימ/י לב:"}
        onClose={() => {hideForbiddenNotice(ordersDispatch);setSaveing(false);}}
        className="pop-up successPopUp pop-up-orange"
        >
        <p>תאריך המשלוח של ההזמנה קרוב מידי או חסום לעדכון</p>
        <DialogActionsBar>
          <button
            className="cancel btn"
            onClick={(e) => {hideForbiddenNotice(ordersDispatch);setSaveing(false);}}
          >
            ביטול
          </button>
          <button className="submit btn" onClick={(e) => {setIgnoreForbidden(true);hideForbiddenNotice(ordersDispatch);}}>
            שליחה בכל זאת
          </button>
        </DialogActionsBar>
        </Dialog> 
      }
      
      {(showMonthOver || showWeekOver || showWeekMin) &&
        <Dialog
        title='שימ/י לב:'
        onClose={(e) => {setShowWeekOver(false);setShowMonthOver(false);setShowWeekMin(false);setSaveing(false);}}
        className="pop-up pop-up-orange"
        >
          {showWeekOver && <div><b>{"הינך חורג מהתקציב השבועי" + (showPrices ? (" ב - " + weekOver.toFixed(2) + " ₪") : "")}</b></div>}
          {showMonthOver && <div><b>{"הינך חורג מהתקציב החודשי" + (showPrices ? (" ב - " + monthOver.toFixed(2) + " ₪") : "")}</b></div>}
          {showWeekMin && <div><b>{"סכום ההזמנה נמוך מהמינימום המותר " + (showPrices ? ("(" + currentOrder.min_order_weekly + " ₪)" ) : "")}</b></div>}
        {(!sendWithNoBudget || !saving) &&<DialogActionsBar>
          <button
            className="submit btn"
            onClick={(e) =>{setShowMonthOver(false);setShowWeekOver(false);setShowWeekMin(false);}}
          >
            אישור 
          </button>
        </DialogActionsBar>}
        { (sendWithNoBudget && saving) &&<DialogActionsBar>
          <button
            className="cancel btn"
            onClick={(e) => {setShowMonthOver(false);setShowWeekOver(false);setShowWeekMin(false);setSaveing(false);}}
          >
            ביטול
          </button>
          <button className="submit btn" onClick={(e) => {setIgnoreBudget(true);setShowMonthOver(false);setShowWeekOver(false);setShowWeekMin(false);}}>
            שליחה בכל זאת
          </button>
        </DialogActionsBar>}
      </Dialog>
      }

      {bad_product&& (
        <Dialog
        title='שימ/י לב:'
        onClose={clearBadProduct}
        className="pop-up pop-up-orange"
        height="250px"
      >
         קיימת בעיה בהוספת המוצר <br/> אנא פנה לשירות לקוחות <br/> 0504535370
        <DialogActionsBar>
          <button
            className="submit btn"
            onClick={clearBadProduct}
          >
            אישור
          </button>
        </DialogActionsBar>
      </Dialog>
      )}

      {enlarged && enlarged.image && (
        <ProductImage
          show={true}
          onClose={(e) => setEnlarged(ordersDispatch, null)}
          images={[enlarged.image, enlarged.image_back]}
          title={enlarged.description}
        />
      )}
    
   
    {credit_process && (
      <Payment amount={totalWithFee} orderId={currentOrder?.fields?.id} showPayment={credit_process} onClose={() => setCreditProcess(ordersDispatch, false)} paymentFinished={paymentFinished}/>
    )}
    </div>
    </BeforeUnloadComponent>
  );
};

export default Order;
